import { MaterialIcons } from '@native-base/icons';
import {
  Center,
  FormControl,
  Heading,
  Icon,
  Input,
  Spacer,
  StatusBar,
  Text,
  VStack,
} from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import { Keyboard, TouchableWithoutFeedback } from 'react-native';

import ActionButton from '../../../shared/ActionButton';

function PaymentInit({ inputValue, onDone, onInputValueChange }) {
  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <VStack height="100%">
        <StatusBar backgroundColor="#F4F8FB" barStyle="dark-content" />
        <Center bg="#F4F8FB" shadow="3" px="4" py="4">
          <Heading>Nouveau paiement</Heading>
        </Center>
        <Center bg="#caf0f8" px="4" py="2">
          <Text>Indiquez le montant du paiement.</Text>
        </Center>
        <Spacer />
        <FormControl px="4" py="4">
          <Input
            autoCapitalize="none"
            autoComplete="off"
            autoCorrect={false}
            autoFocus
            enablesReturnKeyAutomatically
            keyboardType="numeric"
            returnKeyType="done"
            value={String(inputValue)}
            onChangeText={onInputValueChange}
            onSubmitEditing={onDone}
            InputLeftElement={
              <Icon as={MaterialIcons} name="euro" size="sm" ml="2" />
            }
            size="2xl"
            variant="underlined"
            placeholder="10,50€"
          />
        </FormControl>
        <Spacer />
        <ActionButton onPress={onDone}>Continuer</ActionButton>
      </VStack>
    </TouchableWithoutFeedback>
  );
}

PaymentInit.propTypes = {
  inputValue: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
  onInputValueChange: PropTypes.func.isRequired,
};

export default PaymentInit;
